<div class="priority-overlay" *ngIf="isVisible">
  <div class="priority-backdrop" (click)="onCancel()"></div>

  <div class="priority-modal">
    <div class="priority-header">
      <h2>Selecione a Prioridade</h2>
    </div>

    <div class="priority-body" *ngIf="isSimNao">
      <p class="priority-description">Indique se a solicitação possui prioridade:</p>

      <div class="priority-options">
        <div
          class="priority-option"
          [class.selected]="selectedPriority === 'SIM'"
          (click)="selectPriority('SIM')"
        >
          <div class="priority-radio">
            <span class="radio-circle"></span>
          </div>
          <div class="priority-info">
            <span class="priority-name">Sim</span>
          </div>
        </div>

        <div
          class="priority-option"
          [class.selected]="selectedPriority === 'NAO'"
          (click)="selectPriority('NAO')"
        >
          <div class="priority-radio">
            <span class="radio-circle"></span>
          </div>
          <div class="priority-info">
            <span class="priority-name">Não</span>
          </div>
        </div>
      </div>

      <div class="priority-justification" *ngIf="selectedPriority === 'SIM'">
        <label for="priority-justification">Justificativa <span class="required">*</span></label>
        <textarea
          id="priority-justification"
          rows="5"
          maxlength="500"
          placeholder="Informe o motivo da prioridade"
          [(ngModel)]="justification"
        ></textarea>
        <span class="justification-counter">{{ justification.length }}/500</span>
      </div>
    </div>

    <div class="priority-body" *ngIf="!isSimNao">
      <p class="priority-description">
        Defina a prioridade do ticket para calcular o SLA automaticamente:
      </p>

      <div class="priority-options">
        <div
          class="priority-option"
          [class.selected]="selectedPriority === 'ALTA'"
          (click)="selectPriority('ALTA')"
        >
          <div class="priority-radio">
            <span class="radio-circle alta"></span>
          </div>
          <div class="priority-info">
            <span class="priority-name">Alta</span>
            <span class="priority-sla">SLA: 7 dias uteis</span>
          </div>
        </div>

        <div
          class="priority-option"
          [class.selected]="selectedPriority === 'MEDIA'"
          (click)="selectPriority('MEDIA')"
        >
          <div class="priority-radio">
            <span class="radio-circle media"></span>
          </div>
          <div class="priority-info">
            <span class="priority-name">Media</span>
            <span class="priority-sla">SLA: 15 dias uteis</span>
          </div>
        </div>

        <div
          class="priority-option"
          [class.selected]="selectedPriority === 'BAIXA'"
          (click)="selectPriority('BAIXA')"
        >
          <div class="priority-radio">
            <span class="radio-circle baixa"></span>
          </div>
          <div class="priority-info">
            <span class="priority-name">Baixa</span>
            <span class="priority-sla">SLA: 30 dias uteis</span>
          </div>
        </div>
      </div>
    </div>

    <div class="priority-footer">
      <button class="btn-cancel" (click)="onCancel()">Cancelar</button>
      <button
        class="btn-confirm"
        [disabled]="!canConfirm"
        (click)="onConfirm()"
      >
        Confirmar
      </button>
    </div>
  </div>
</div>
